import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import AddCommentIcon from '@mui/icons-material/AddComment'
import AddToQueueIcon from '@mui/icons-material/AddToQueue'
import ArticleIcon from '@mui/icons-material/Article'
import BadgeIcon from '@mui/icons-material/Badge'
import BlockIcon from '@mui/icons-material/Block'
import CardMembershipIcon from '@mui/icons-material/CardMembership'
import ChatIcon from '@mui/icons-material/Chat'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EqualizerIcon from '@mui/icons-material/Equalizer'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import GroupIcon from '@mui/icons-material/Group'
import HailIcon from '@mui/icons-material/Hail'
import HandymanIcon from '@mui/icons-material/Handyman'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import NotificationsIcon from '@mui/icons-material/Notifications'
import PaidIcon from '@mui/icons-material/Paid'
import PeopleIcon from '@mui/icons-material/People'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import RememberMeIcon from '@mui/icons-material/RememberMe'
import SegmentIcon from '@mui/icons-material/Segment'
import SettingsIcon from '@mui/icons-material/Settings'
import ThreePIcon from '@mui/icons-material/ThreeP'
import TimelineIcon from '@mui/icons-material/Timeline'
import TodayIcon from '@mui/icons-material/Today'
import PersonIcon from '@mui/icons-material/Person'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle'
import PollIcon from '@mui/icons-material/Poll'
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';
import ConstructionIcon from '@mui/icons-material/Construction';

import { RoutesMap } from '../../types'
import { routeAdminType } from '../../types/typeComponents/NavSection'

export const icons = {
  AddCommentIcon,
  AddToQueueIcon,
  ArticleIcon,
  BadgeIcon,
  ChatIcon,
  ContentPasteIcon,
  DashboardIcon,
  EqualizerIcon,
  FormatListBulletedIcon,
  GroupIcon,
  HailIcon,
  HandymanIcon,
  PaidIcon,
  PeopleIcon,
  PeopleAltIcon,
  PermContactCalendarIcon,
  SegmentIcon,
  SettingsIcon,
  ThreePIcon,
  TimelineIcon,
  ManageAccountsIcon,
  AccountCircleIcon,
  NotificationsIcon,
  RememberMeIcon,
  CardMembershipIcon,
  TodayIcon,
  BlockIcon,
  ReceiptLongIcon,
  ConstructionIcon
}

const rutasAdmin: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <PersonIcon />,
    rutas: [
      {
        name_ruta: 'Propietarios',
        location: RoutesMap.OWNER,
        icon: null,
      },
      {
        name_ruta: 'Departamentos',
        location: RoutesMap.DEPARTAMENT,
        icon: null,
      },
      {
        name_ruta: 'Gastos',
        location: RoutesMap.PAYMENT_CONCEPT,
        icon: null,
      },
      {
        name_ruta: 'Concepto de Categorias',
        location: RoutesMap.CONCEPT_CATEGORY,
        icon: null,
      },
      {
        name_ruta: 'Servicios',
        location: RoutesMap.SERVICES,
        icon: null,
      }

    ]
  },
  {
    id: 3,
    name: 'Rendiciones',
    icon: <PaidIcon />,
    rutas: [
      {
        name_ruta: 'Apertura',
        location: RoutesMap.RENDITION_ADMIN_OPEN,
        icon: null,
      },
      {
        name_ruta: 'Listado',
        location: RoutesMap.RENDITION_ADMIN_LIST,
        icon: null,
      }
    ]
  },
  {
    id: 5,
    name: 'Reportes',
    icon: <PollIcon />,
    rutas: [
      {
        name_ruta: 'Pago de rendiciones',
        location: RoutesMap.REPORT_ADMIN_RENDITION_PAY,
        icon: null,
      },
      {
        name_ruta: 'Rendiciones',
        location: RoutesMap.REPORT_ADMIN_RENDITION,
        icon: null,
      },
      {
        name_ruta: 'Cartola',
        location: RoutesMap.REPORT_CARTOLA,
        icon: null,
      },
      {
        name_ruta: 'Cartola de edificio',
        location: RoutesMap.REPORT_CARTOLA_BUILDING,
        icon: null,
      },
    ]
  },
  {
    id: 6,
    name: 'Ajustes',
    icon: <SettingsIcon />,
    rutas: [
      {
        name_ruta: 'Política de corte o suspención',
        location: RoutesMap.SETTING_ADMIN_CESSATION,
        icon: null,
      },
      {
        name_ruta: 'Política de ciclo de rendiciones',
        location: RoutesMap.SETTING_ADMIN_CYLE_RENDITION,
        icon: null,
      },
    ]
  },
]

const rutasAdminBuilding: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <ConstructionIcon />,
    rutas: [
      {
        name_ruta: 'Departamentos',
        location: RoutesMap.DEPARTAMENT,
        icon: null,
      },
      {
        name_ruta: 'Edificios',
        location: RoutesMap.BUILDING,
        icon: null,
      },
      {
        name_ruta: 'Propietarios',
        location: RoutesMap.OWNER,
        icon: null,
      },
      {
        name_ruta: 'Arrendatario',
        location: RoutesMap.TENANT,
        icon: null,
      },
      {
        name_ruta: 'Corredor',
        location: RoutesMap.AGENT,
        icon: null,
      },
      {
        name_ruta: 'Concepto de categorias',
        location: RoutesMap.CONCEPT_CATEGORY,
        icon: null,
      },
      {
        name_ruta: 'Gastos',
        location: RoutesMap.PAYMENT_CONCEPT,
        icon: null,
      },
      {
        name_ruta: 'Servicios',
        location: RoutesMap.SERVICES,
        icon: null,
      }

    ]
  },
  {
    id: 3,
    name: 'Rendiciones',
    icon: <PaidIcon />,
    rutas: [
      {
        name_ruta: 'Apertura',
        location: RoutesMap.RENDITION_ADMIN_BUILDING_OPEN,
        icon: null,
      },
      {
        name_ruta: 'Listado',
        location: RoutesMap.RENDITION_ADMIN_BUILDING_LIST,
        icon: null,
      }
    ]
  },
  {
    id: 5,
    name: 'Contratos',
    icon: <BorderColorIcon />,
    rutas: [
      {
        name_ruta: 'Variables',
        location: RoutesMap.TEMPLATE_VARIABLES,
        icon: null,
      },
      // {
      //   name_ruta: 'Contrato arrendador',
      //   location: RoutesMap.RENTAL_CONTRACT,
      //   icon: null,
      // },
      {
        name_ruta: 'Plantillas',
        location: RoutesMap.LIST_CONTRACT_TEMPLATE,
        icon: null,
      },
      {
        name_ruta: 'Crear nueva plantilla',
        location: RoutesMap.CREATE_CONTRACT,
        icon: null,
      }
    ]
  },
  {
    id: 6,
    name: 'Reportes',
    icon: <PollIcon />,
    rutas: [
      {
        name_ruta: 'Pago de rendiciones',
        location: RoutesMap.REPORT_ADMIN_RENDITION_PAY,
        icon: null,
      },
      {
        name_ruta: 'Reporte de deudas',
        location: RoutesMap.REPORT_ADMIN_RENDITION,
        icon: null,
      },
      {
        name_ruta: 'Cartola de departamentos',
        location: RoutesMap.REPORT_CARTOLA,
        icon: null,
      },
      {
        name_ruta: 'Cartola de edificio',
        location: RoutesMap.REPORT_CARTOLA_BUILDING,
        icon: null,
      },
    ]
  },
  {
    id: 7,
    name: 'Documentos',
    icon: <FolderIcon />,
    rutas: [
      {
        name_ruta: 'Documentos',
        location: RoutesMap.DOCUMENTS_LIST_USER,
        icon: null,
      },
      {
        name_ruta: 'Mis documentos',
        location: RoutesMap.MY_DOCUMENTS,
        icon: null,
      }
    ]
  },
  // {
  //   id: 8,
  //   name: 'Ajustes',
  //   icon: <SettingsIcon />,
  //   rutas: [
  //     {
  //       name_ruta: 'Política de corte o suspención',
  //       location: RoutesMap.SETTING_ADMIN_CESSATION,
  //       icon: null,
  //     },
  //     {
  //       name_ruta: 'Política de ciclo de rendiciones',
  //       location: RoutesMap.SETTING_ADMIN_CYLE_RENDITION,
  //       icon: null,
  //     },
  //   ]
  // },
]

const rutasSuperAdmin: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <PersonIcon />,
    rutas: [
      {
        name_ruta: 'Empresas',
        location: RoutesMap.COMPANIES,
        icon: null,
      },
      {
        name_ruta: 'Administradores',
        location: RoutesMap.ADMINISTRATOR,
        icon: null,
      },

    ]
  },
  // {
  //   id: 2,
  //   name: 'Ajustes',
  //   icon: <SettingsIcon />,
  //   rutas: [
  //     {
  //       name_ruta: 'Política de reservación',
  //       location: RoutesMap.SETTING_SUPERADMIN_RESERVATION,
  //       icon: null,
  //     },
  //   ]
  // },
]

const rutasOwner: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <PersonIcon />,
    rutas: [
      {
        name_ruta: 'Departamentos',
        location: RoutesMap.DEPARTAMENT,
        icon: null,
      },
      {
        name_ruta: 'Arrendatario',
        location: RoutesMap.TENANT,
        icon: null,
      },
      {
        name_ruta: 'Corredor',
        location: RoutesMap.AGENT,
        icon: null,
      },
      {
        name_ruta: 'Gastos',
        location: RoutesMap.PAYMENT_CONCEPT,
        icon: null,
      },
      {
        name_ruta: 'Concepto de Categorias',
        location: RoutesMap.CONCEPT_CATEGORY,
        icon: null,
      },
      {
        name_ruta: 'Servicios',
        location: RoutesMap.SERVICES,
        icon: null,
      }

    ]
  },
  {
    id: 3,
    name: 'Rendiciones',
    icon: <PaidIcon />,
    rutas: [
      {
        name_ruta: 'Mi Rendición',
        location: RoutesMap.RENDITION,
        icon: null,
      }
    ]
  },
  {
    id: 4,
    name: 'Contratos',
    icon: <BorderColorIcon />,
    rutas: [
      // {
      //   name_ruta: 'Contrato Arrendador',
      //   location: RoutesMap.RENTAL_CONTRACT_OWNER,
      //   icon: null,
      // },
      {
        name_ruta: 'Plantillas',
        location: RoutesMap.LIST_CONTRACT_TEMPLATE_OWNER,
        icon: null,
      }
      // {
      //   name_ruta: 'Contrato corredor',
      //   location: RoutesMap.ESTATE_AGENT_CONTRACT,
      //   icon: null,
      // }
    ]
  },
  {
    id: 5,
    name: 'Documentos',
    icon: <FolderIcon />,
    rutas: [
      {
        name_ruta: 'Mis documentos',
        location: RoutesMap.MY_DOCUMENTS,
        icon: null,
      }
    ]
  },
  {
    id: 6,
    name: 'Ajustes',
    icon: <SettingsIcon />,
    rutas: [
      {
        name_ruta: 'Política de corte o suspención',
        location: RoutesMap.SETTING_ADMIN_CESSATION,
        icon: null,
      },
      {
        name_ruta: 'Política de ciclo de rendiciones',
        location: RoutesMap.SETTING_ADMIN_CYLE_RENDITION,
        icon: null,
      },
    ]
  },
]

const rutasTenant: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <PersonIcon />,
    rutas: [
      {
        name_ruta: 'Departamentos',
        location: RoutesMap.DEPARTAMENT,
        icon: null,
      },
      // {
      //   name_ruta: 'Corredor',
      //   location: RoutesMap.AGENT,
      //   icon: null,
      // },
    ]
  },
  {
    id: 2,
    name: 'Rendiciones',
    icon: <PaidIcon />,
    rutas: [
      {
        name_ruta: 'Mi rendición',
        location: RoutesMap.RENDITION,
        icon: null,
      }
    ]
  },
  {
    id: 3,
    name: 'Contrato',
    icon: <DescriptionIcon />,
    rutas: [
      {
        name_ruta: 'Mi contrato',
        location: RoutesMap.MY_CONTRACT,
        icon: null,
      }
    ]
  },
  {
    id: 4,
    name: 'Documentos',
    icon: <FolderIcon />,
    rutas: [
      {
        name_ruta: 'Mis documentos',
        location: RoutesMap.MY_DOCUMENTS,
        icon: null,
      }
    ]
  },
]

const rutasAgent: routeAdminType[] = [
  {
    id: 1,
    name: 'Maestros',
    icon: <PersonIcon />,
    rutas: [
      {
        name_ruta: 'Arrendatario',
        location: RoutesMap.TENANT,
        icon: null,
      },
      {
        name_ruta: 'Departamentos',
        location: RoutesMap.DEPARTAMENT,
        icon: null,
      },

    ]
  },
  {
    id: 2,
    name: 'Rendiciones',
    icon: <PaidIcon />,
    rutas: [
      {
        name_ruta: 'Apertura',
        location: RoutesMap.RENDITION_ADMIN_BUILDING_OPEN,
        icon: null,
      },
      {
        name_ruta: 'Listado',
        location: RoutesMap.RENDITION_ADMIN_BUILDING_LIST,
        icon: null,
      }
    ]
  },
  {
    id: 3,
    name: 'Documentos',
    icon: <FolderIcon />,
    rutas: [
      {
        name_ruta: 'Mis documentos',
        location: RoutesMap.MY_DOCUMENTS,
        icon: null,
      }
    ]
  },
]

export const navSections = {
  'Superadmin': rutasSuperAdmin,
  'Admin': rutasAdmin,
  'AdminBuilding': rutasAdminBuilding,
  'Agent': rutasAgent,
  'Tenant': rutasTenant,
  'Owner': rutasOwner
}
